//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnIpAddressFilterService', tableColumnIpAddressFilterService);

    function tableColumnIpAddressFilterService(sortService) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            switch (data.ipAddressFilterType) {
                case 'none': default: {
                    break;
                }
                case 'single': {
                    filteredItems = filteredItems.filter(item => item[data.columnKey] == data.singleIpAddress.value);
                    break;
                }
                case 'range': {

                    filteredItems = filteredItems.filter(item => {
                        return item[data.columnKey].split('.').every((octet, i) => {
                            return octet >= data.fromIpAddress.octets[i] && octet <= data.toIpAddress.octets[i];
                        });
                    });
                    break;
                }
            }

            // Filter by ip address string
            if (data.searchText) {
                filteredItems = filteredItems.filter(item => item[data.columnKey].indexOf(data.searchText) > -1);
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByIpAddress(filteredItems, data.columnKey, data.column.sortDirection == 'asc');
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();